import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"

import { NoWrapTableCell } from "../../../common/components/tables/cells"
import { trimLongString } from "../../../common/utils"
import CandidatePriceTagChip from "../components/CandidatePriceTagChip"

export function LeadTagsCell({ lead }) {
  const tags = lead?.custom_tags ?? []
  return (
    <NoWrapTableCell>
      <Stack
        direction="row"
        flexWrap="wrap"
        sx={{ maxWidth: 220, py: 0.25, gap: 0.5 }}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {tags.length === 0 ? (
          <Typography variant="caption" color="text.secondary">
            —
          </Typography>
        ) : (
          tags.map((tag, i) => (
            <CandidatePriceTagChip
              key={`${lead.id}-${i}-${tag}`}
              label={trimLongString(tag, 24)}
              title={tag}
              maxWidth={160}
            />
          ))
        )}
      </Stack>
    </NoWrapTableCell>
  )
}

export function LeadTagsLoadingCell() {
  return <NoWrapTableCell>—</NoWrapTableCell>
}
